import React, { useState, useCallback } from 'react';
import { DataGrid, Column, HeaderFilter,
  Paging, SearchPanel, Export,
} from 'devextreme-react/data-grid';
import {SIFReportingCompanies, SIFFilter} from '../'
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { exportDataGrid as xlsExportDataGrid } from 'devextreme/excel_exporter';

export default function SIFReportData(props) {
  const [data, setData] = useState();

  const onFilterDataChanged = useCallback((data) => {
    setData([...data]);
  }, []);

  const onExporting = useCallback((e) => {
    if (e.format === "xlsx") {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('Main sheet');

      xlsExportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'AXPC-SIF-Events.xlsx');
        });
      });
    }
  }, []);

  const calculateAP = (rowData) => {
    if ((parseInt(rowData['Number of Fatalities']) || 0)+(parseInt(rowData['Number of Serious Injuries']) || 0)) {
      return "Actual";
    }
    return "Potential";
  }

  return (
    <div>
      <SIFFilter
        data={props.data}
        startDate={props.startDate}
        endDate={props.endDate}
        onFilteredDataChanged={onFilterDataChanged}
        showArea={false}
        showDisciplines={false}
        showActivities={false}
        showPrimaryFactor={false}
        showPotentialActual={false}
        showCategories={false}
        showTimeOfDay={false}
      />

      {props.data && <div className={'content-block'}>

        <DataGrid id="dataGrid"
          dataSource={props.data}
          columnHidingEnabled={true}
          cellHintEnabled={true}
          wordWrapEnabled={true}
          onExporting={onExporting}
        >
          <Export enabled={true} formats={['xlsx']} />
          <HeaderFilter visible={true} />
          <SearchPanel visible={true} width="300px"/>

          <Column
            dataField={'DATE OF EVENT (m/d/yyyy)'}
            caption={'Date'}
            dataType="date"
            defaultSortOrder="desc"
            visibleIndex={1}
            width="120px"
          >
          </Column>
          <Column
            dataField={'Time of Event'}
            caption={'Time'}
            visibleIndex={2}
            hidingPriority={23}
            width="190px"
          >
          </Column>
          <Column
            dataField={'Area/Basin'}
            caption={'Area/Basin'}
            visibleIndex={3}
            hidingPriority={30}
            width="150px"
          >
          </Column>
          <Column
            dataField={'State'}
            caption={'State'}
            visibleIndex={4}
            hidingPriority={29}
            width="90px"
          >
          </Column>
          {false && <Column
            dataField={'County'}
            caption={'County'}
            visibleIndex={5}
            hidingPriority={22}
            width="120px"
          >
          </Column>}
          <Column
            dataField={'Potential or Actual SIF'}
            caption={'Type'}
            calculateCellValue={calculateAP}
            visibleIndex={6}
            hidingPriority={28}
            width="90px"
          >
          </Column>
          <Column
            dataField={'Number of Fatalities'}
            caption={'Fatalities'}
            visibleIndex={7}
            hidingPriority={27}
            width="120px"
          >
          </Column>
          <Column
            dataField={'Number of Serious Injuries'}
            caption={'Injuries'}
            visibleIndex={8}
            hidingPriority={26}
            width="110px"
          >
          </Column>
          <Column
            dataField={'SIF CATEGORY'}
            caption={'Category'}
            visibleIndex={9}
            hidingPriority={25}
            width="220px"
          >
          </Column>
          <Column
            dataField={'SIF Condition'}
            caption={'Condition'}
            visibleIndex={10}
            hidingPriority={21}
            width="200px"
          >
          </Column>
          <Column
            dataField={'IOGP Life-Saving Rule Violation'}
            caption={'IOGP Life-Saving Rule Violation'}
            visibleIndex={12}
            hidingPriority={18}
            width="150px"
          >
          </Column>
          <Column
            dataField={'Discipline of Activity at Time of Event'}
            caption={'Discipline'}
            visibleIndex={13}
            hidingPriority={24}
            width="220px"
          >
          </Column>

          <Column
            dataField={'Activity at Time of Event'}
            caption={'Activity'}
            visibleIndex={14}
            hidingPriority={20}
            width="150px"
          >
          </Column>

          <Column
            dataField={'Activity Subgroup or Task'}
            caption={'Activity Subgroup or Task'}
            visibleIndex={15}
            hidingPriority={19}
            width="150px"
          >
          </Column>

          <Column
            dataField={'DESCRIPTION OF INCIDENT'}
            caption={'Description of Incident'}
            visibleIndex={16}
            hidingPriority={11}
            width="150px"
          >
          </Column>

          <Column
            dataField={'Was it reasonable that a person was or could have been in proximity at the time of the event?'}
            caption={'Was it reasonable that a person was or could have been in proximity at the time of the event?'}
            visibleIndex={17}
            hidingPriority={14}
            width="150px"
          >
          </Column>

          <Column
            dataField={'Did a barrier/control prevent or mitigate the event from becoming an Actual SIF?'}
            caption={'Did a barrier/control prevent or mitigate the event from becoming an Actual SIF?'}
            visibleIndex={18}
            hidingPriority={13}
            width="150px"
          >
          </Column>

          <Column
            dataField={'Primary Causal Factors'}
            caption={'Primary Causal Factors'}
            visibleIndex={19}
            hidingPriority={16}
            width="150px"
          >
          </Column>

          <Column
            dataField={'Cause Description'}
            caption={'Cause Description'}
            visibleIndex={20}
            hidingPriority={15}
            width="150px"
          >
          </Column>
          <Column
            dataField={'What is the status of the Causal Investigation?'}
            caption={'Investigation Status'}
            visibleIndex={21}
            hidingPriority={12}
            width="150px"
          >
          </Column>

          <Paging defaultPageSize={100} />
        </DataGrid>
      </div>}

      <SIFReportingCompanies data={data}/>

    </div>
  );
}
